module.exports = __webpack_public_path__ + "static/media/Asset 60.47718d33.jpg";